import React from "react";
import { StaticContext } from "react-router";
import { RouteComponentProps, withRouter } from "react-router-dom";
// MUI
import { Avatar, ListItem, ListItemAvatar, ListItemText } from "@mui/material";
import { WithStyles, WithTheme } from "@mui/styles";
import withStyles from "@mui/styles/withStyles";
import { styles } from "pages/management/treeView/clusterItem/styles";
// icons
import { AddCircleOutline as AddCircleOutlineIcon } from "@mui/icons-material";
// redux
import { AppState } from "AppState";
import { clusterCreateWizardShow } from "pages/management/cluster/clusterCreateWizard/actions";
import { connect } from "react-redux";

// component local state interface
interface State {}

// PROPS
interface StateProps {}

interface DispatchProps {
	clusterCreateWizardShow: () => void;
}

type Props = StateProps &
	DispatchProps &
	WithStyles<typeof styles> &
	WithTheme &
	RouteComponentProps<any, StaticContext, any>;

// COMPONENT
class NoClusterItemComponent extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);

		this.state = {};
	}

	onItemClick = () => {
		this.props.clusterCreateWizardShow();
	};

	render(): React.ReactNode {
		const { classes } = this.props;

		return (
			<>
				<ListItem button onClick={this.onItemClick}>
					<ListItemAvatar>
						<Avatar className={classes.clusterItemAvatar}>
							<AddCircleOutlineIcon className={classes.clusterItemAvatarIcon} />
						</Avatar>
					</ListItemAvatar>
					<ListItemText
						primary={"No clusters"}
						secondary={"Click here to create first cluster"}
					/>
				</ListItem>
			</>
		);
	}
}

// REDUX MAPPINGS
const mapGlobalStateToProps = (state: AppState) => {
	return {};
};

const mapGlobalDispatchToProps = (dispatch: any) => {
	return {
		clusterCreateWizardShow: () => {
			dispatch(clusterCreateWizardShow());
		}
	};
};

export default withStyles(styles, { withTheme: true })(
	withRouter(
		connect(
			mapGlobalStateToProps,
			mapGlobalDispatchToProps
		)(NoClusterItemComponent)
	)
);
